import { listRefs, type GameMod } from '../api/game-refs';

// ============================================================
// Авторы модов для автоподстановки (модалка мода + админка).
// Источник — справочник модов; кэш 30с, чтобы не дёргать API на каждую карточку.
// ============================================================

let authors: string[] = [];
let fetchedAt = 0;
let pending: Promise<void> | null = null;

/** Уникальные непустые авторы по алфавиту. */
function normalizeAuthors(list: Array<string | null | undefined>): string[] {
    return [...new Set(
        list.filter((a): a is string => typeof a === 'string' && !!a.trim())
    )].sort((a, b) => a.localeCompare(b));
}

/** Задать авторов из уже загруженного списка модов (без запроса). */
export function setModAuthors(list: Array<string | null | undefined>): void {
    authors = normalizeAuthors(list);
    fetchedAt = Date.now();
}

/** Текущий список авторов (для выпадашки автокомплита). */
export function getModAuthors(): string[] {
    return authors;
}

/** Подгружает авторов из справочника модов, если кэш устарел. */
export function loadModAuthors(maxAgeMs = 30_000): Promise<void> {
    if (Date.now() - fetchedAt < maxAgeMs) return Promise.resolve();
    if (pending) return pending;
    pending = (async () => {
        try {
            const mods = await listRefs<GameMod>('mods');
            setModAuthors(mods.map((m) => m.author));
        } catch {
            /* подсказки не критичны */
        } finally {
            pending = null;
        }
    })();
    return pending;
}
